module.exports = __webpack_public_path__ + "img/videoImg.059bd35d.png";